<script>
    import { onMount, onDestroy } from "svelte";
    import { Readability } from '@mozilla/readability';
    import DOMPurify from 'dompurify';
    import { getItem } from '../helpers.svelte';
    // import { html as mockHtmlString } from '../mocks/Mocks.svelte'
    import Icon from 'svelte-awesome';
    import { close, arrowUp } from 'svelte-awesome/icons';
    import TranscludedItem from '../components/TranscludedItem.svelte';
    import { navigate } from "svelte-routing";
    import { queryLinkedItems } from '../stores/helpers';
    export let itemID;
    let item = {};
    let linkedItemsIDs = [];
    let showUpArrow = false;
    let htmlString;
    let tweetString;
    let articleContent = `<div class="blurry-text articleshadow">
        <div>
        All truths are easy to understand once they are discovered; the point is to discover them.
        Galileo Galilei
        
        I am a firm believer in the people. If given the truth, they can be depended upon to meet any national crisis. The great point is to bring them the real facts.
        Abraham Lincoln
        </div>
        <br>
        <div>
        Tell me I'm clever, Tell me I'm kind, Tell me I'm talented, Tell me I'm cute, Tell me I'm sensitive, Graceful and wise, Tell me I'm perfect - But tell me the truth.
        Shel Silverstein
        </div>
    </div>`;

    // stuff that comes from processing linkedItemsIDs
    // let tags = [];
    $: tags = linkedItemsIDs.map(linkedItemsByTag => linkedItemsByTag[0])

    var stringToHTML = function (str) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(str, 'text/html');
        return doc;
    };

    const getHtml = (url) => {
        return fetch(`/api/v1/get-html`, {
          body: JSON.stringify({
              url,
          }),
          method: 'POST',
          'content-type': 'application/json',
        })
        .then(res => res.json())
    }

    // const getHtmlMock = (url) => {
    //     return new Promise((resolve) => resolve({ html: mockHtmlString }));
    // }

    function scrollIntoView({ itemID }) {
		const el = document.querySelector('#article-container-top-target');
		if (!el) return;
        el.scrollIntoView();
    }

    const goToTag = (tag) => {
        const el = document.querySelector(`#${tag.substring(1)}-id`);
        if (!el) return;
        el.scrollIntoView({
            behavior: 'smooth'
        });
    }

    $: {
        articleContent = `<div class="blurry-text articleshadow">
            <div>
            All truths are easy to understand once they are discovered; the point is to discover them.
            Galileo Galilei
            
            I am a firm believer in the people. If given the truth, they can be depended upon to meet any national crisis. The great point is to bring them the real facts.
            Abraham Lincoln
            </div>
            <br>
            <div>
            Tell me I'm clever, Tell me I'm kind, Tell me I'm talented, Tell me I'm cute, Tell me I'm sensitive, Graceful and wise, Tell me I'm perfect - But tell me the truth.
            Shel Silverstein
            </div>
        </div>`;
        scrollIntoView({ itemID })
    }
    
    onMount(() => {
        document.body.classList.add('noscroll');
    })
    onDestroy(() => {
        document.body.classList.remove('noscroll');
    })

    $: item = getItem(itemID)
    $: {
        ({ linkedItemsIDs = [] } = queryLinkedItems(item))
        
        linkedItemsIDs.sort((tagArr1, tagArr2) => {
            return tagArr1[1].length - tagArr2[1].length
        })
    }

    
    $: {
        if (item.link) {
            getHtml(item.link).then(res => {
                // htmlString = res.html
                if (!res.success) {
                    if (item.textBody) {
                        articleContent = `<div>${item.textBody}</div>`
                    } else {
                        articleContent = '<div>sorry, no content</div>'
                    }
                    return;
                }

                if (res.contentType === 'HTML') {
                    htmlString = res.content;
                } else if (res.contentType === 'TWEET') {
                    tweetString = res.content;
                }
            });
            // getHtmlMock(item.link).then(res => htmlString = res.html);
        } else {
            articleContent = `<div>${item.textBody}</div>`
        }
    }
    $: {
        if (htmlString) {
            const document = stringToHTML(htmlString)
            const article = new Readability(document).parse();
            const content = DOMPurify.sanitize(article.content);

            setTimeout(() => {
                articleContent = content
            }, 400)
        }
        // articleContent = article.content.replace(/([\n\r])\1+/g, '\n');
    }
    $: {
        if (tweetString) {
            setTimeout(() => {
                articleContent = tweetString
            }, 400)
        }
    }

    const onClose = (event) => {
        navigate('/home');
    }
    const onMainScroll = (event) => {
        if (event.target.scrollTop > 500) {
            showUpArrow = true;
        } else {
            showUpArrow = false;
        }
    }
</script>

<!-- <svelte:window bind:scrollY /> -->

<main id='article-container' on:scroll="{onMainScroll}">
    <span id='article-container-top-target'></span>
    <div class="close-container" on:click="{onClose}"><Icon data={close} scale={2}></Icon></div>
    <div class="up-arrow-container" class:showUpArrow on:click="{scrollIntoView}"><Icon data={arrowUp} scale={2}></Icon></div>
    <div class="item-detail-view-container">
        {#if item.title}
            <h2>{item.title}</h2>
        {/if}
        <div>
            {#each tags as tag}
                <span class="tag-name" on:click="{() => goToTag(tag)}">{tag}</span>
            {/each}
        </div>
        <div class="content-body" style="">
            {@html articleContent}
        </div>
        {#if item.link}
            <div class="link-container">continue at <br> <a href="{ item.link }" target="_blank">{ item.link }</a></div>
        {/if}
        <div class="linked-items-container">
            {#each linkedItemsIDs as [tag, itemIdentifiers]}
                {#if itemIdentifiers.length}
                    <div class="tag-header" id="{tag.substring(1)}-id">{tag}</div>
                    <div>
                        {#each itemIdentifiers as itemIdentifier}
                            <div>
                                <TranscludedItem itemIdentifier={itemIdentifier} />
                            </div>
                        {/each}
                    </div>
                {/if}
            {/each}
        </div>
        <div class="item-bottom-nav">
            {#each tags as tag}
                <span class="tag-name" on:click="{() => goToTag(tag)}">{tag}</span>
            {/each}
        </div>
    </div>
</main>

<style>
    main {
        background:white;
        position:fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        padding-top: 100px;
        overflow: scroll;
    }
    .item-detail-view-container {
        max-width: 600px;
        margin:auto;
        margin-bottom:60px;
    }
    .tag-name {
        margin-right: 24px;
        cursor: pointer;
    }
    .item-bottom-nav .tag-name {
        padding: 10px;
        color: rgb(0,100,200);
    }
    .content-body {
        margin-top: 30px;
        font-size: 18px;
        line-height: 1.84;
        letter-spacing: 0px;
        min-height: 250px;
    }
    .linked-items-container {
        margin-top: 40px;
    }
    .tag-header {
        font-weight: 600;
        margin-top: 40px;
    }
    .close-container {
        position: absolute;
        top: 50px;
        right: 50px;
    }
    .up-arrow-container {
        position: fixed;
        right: 50px;
        top: 50px;
        opacity: .5;
        background: gray;
        padding: 10px;
        border-radius: 4px;
        display:none;
        cursor: pointer;
    }
    .up-arrow-container.showUpArrow {
        display:block;
    }
    .link-container {
        margin-top: 10px;
        padding: 8px;
        text-align: center;
        background: whitesmoke;
        border-radius: 4px;
    }
    .link-container > a {
        font-size: 14px;
    }
    #article-container-top-target {
        position:absolute;
        top:0;
    }

    .item-bottom-nav {
        position: fixed;
        /* left: 50%; */
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 999999999;
        display: block;
        width: 100%;
        background-color: whitesmoke;
        /* -webkit-transform: translate(-50%,0);
        -ms-transform: translate(-50%,0);
        transform: translate(-50%,0); */
        color: #4d4d4d;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
    }

    /* smaller screens - padding, img */
    @media only screen and (max-width: 767px) {
        .item-detail-view-container {
            padding: 20px;
        }
    }
    
</style>